import { TListId } from '../../types/types';

export const getListIdFromUrl = (
    url: string
): TListId => {
    const list= url.match(/\/l-\d{16}/);
    return list && Number(list[0].slice(3));
}
